import CollaboratorList from './CollaboratorList';
import { collaborators } from './dummyData';
export default CollaboratorList;
export { collaborators };
